<template>
  <div class="activity-progress">
    <div v-for="(item, index) in data" :key="item.virtual_currency_val" class="activity-progress__node" :style="{ top: (index  * (isMobile ? 180 : 156)) + 'px' }">
      <bg-style class="relative z-10 node-text" :bg="model.progressNodeBackground">
        <span class="relative">{{ item.virtual_currency_val }}</span>
      </bg-style>
    </div>
    <bg-style class="activity-progress__bar" :bg="model.progressBackground">
      <bg-style class="w-full h-[50px]" :bg="model.progressInnerBackground" />
    </bg-style>
  </div>
</template>

<script>
export default {
  name: 'ActivityProgress',
  props: {
    data: {
      type: Array,
      default() {
        return []
      }
    },
    isMobile: {
      type: Boolean,
      default: false
    },
    model: {
      type: Object,
      default() {
        return {
        }
      }
    }
  },
  data() {
    return {
    }
  },
  computed: {
  }
}
</script>

<style lang="less">
.activity-progress {
  margin-right: 30px;
  height: auto;
  position: relative;
  &.mobile {
    .activity-progress__node {
      height: 180px;
      padding-bottom: 44px;
    }
  }
  &__bar {
    width: 16px;
    height: 100%;
    border-radius: 16px;
    flex-shrink: 0;
    overflow: hidden;
    position: relative;
  }
  &__node {
    position: absolute;
    height: 156px;
    width: 100%;
    top: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    .node-text {
      padding: 4px 16px;
    }
  }
}
</style>
